import React from "react";
import { ServiceItem } from "../../HomeTwo/Services";

const OurService = () => {
  return (
    <>
      <div className="tp-service-ara grey-bg-4 pt-140 pb-110">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="tp-section-wrapper text-center mb-70">
                <span className="tp-section-subtitle mb-30">OUR SERVICES</span>
                <h2 className="tp-section-title">
                  Explore Our Elevator Services
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
          <ServiceItem
              link="/new-installation"
              icon="pe-7s-arc"
              title="New Installation"
              desc="Installation works are carried out after discussions on the type of lifts required to meet the demands of the buildings, using the latest technology equipment."
            />
            <ServiceItem
            link="/maintenance-contract"
              icon="pe-7s-cloud-download"
              title="Maintenance Contract"
              desc="We are one of the reliable and well know service providers for elevators maintenance. We offer our clients annual maintenance contract for all types of lifts"
            />
            <ServiceItem
            link="/modification"
              icon="pe-7s-disk"
              title="Modification"
              desc="We modify our clients
              elevator with the latest
              and updated techniques,
              technology features to
              ensure maximum safety
              and to reduce the energy
              cost."
            />
            <ServiceItem
            link = "/repair-and-service"
              icon="pe-7s-hammer"
              title="Repair and
              Service"
              desc="We posses dynamic
              professionals to provide
              repairing and other
              maintenance service at
              market price for better
              functioning of the
              elevators and its inner
              devices."
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default OurService;
